export class StatusModel {
    static model = [
      {
        label: 'Pendiente', value: 0, key: 'pending'
      },
      {
        label: 'Aprobado', value: 1, key: 'approve'
      },
      {
        label: 'Denegado', value: 2, key: 'reject'
      }
    ]
}
